import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import {
	Avatar,
	CloseIcon,
	Ellipsis,
	FlexGap,
	IconButton,
	Paragraph,
	Pill,
	Spinner,
	tokens,
} from '@treams/treams-ui';

import { Recipient, isUserRecipient } from '../../../kakapo-ui-services/models/Recipient';

interface IProps {
	recipient: Recipient;
	onRemove: () => void;
	loading?: boolean;
}

export default function RecipientFieldReadonly({ recipient, onRemove, loading }: IProps) {
	const { t } = useTranslation();
	const label = isUserRecipient(recipient)
		? `${recipient.userData.firstName} ${recipient.userData.lastName}`
		: recipient.name;

	return (
		<FlexGap alignItems="center" gap={tokens.gap.element} width="100%">
			{isUserRecipient(recipient) ? (
				<Avatar user={recipient.userData} size={24} />
			) : (
				<Avatar
					user={{
						firstName: recipient.name?.toUpperCase(),
						lastName: '',
					}}
					size={24}
				/>
			)}
			<Box flex={1} minWidth={0}>
				<Ellipsis>
					<Paragraph>{label}</Paragraph>
				</Ellipsis>
				{!isUserRecipient(recipient) && (
					<Ellipsis>
						<Paragraph small>{recipient.email}</Paragraph>
					</Ellipsis>
				)}
			</Box>
			{!isUserRecipient(recipient) && <Pill small>{t('recipient.selector.external.badge')}</Pill>}
			{loading ? (
				<Spinner />
			) : (
				<IconButton icon={<CloseIcon />} type="secondary" onClick={onRemove} />
			)}
		</FlexGap>
	);
}
